<template>
  <div class="filter" :class="extendedFilter ? 'filter--extended' : ''">
    <!-- Operator -->
    <q-select
      class="select"
      :display-value="
        ` ${
          persistentOperatorFilter.OperatorID === 0
            ? 'All Operators'
            : persistentOperatorFilter.Operator
        }`
      "
      virtual-scroll-slice-size="30"
      virtual-scroll-item-size="30"
      popup-content-class="select__options"
      dense
      options-dense
      v-model="selectedOperator"
      :options="operatorList"
      option-value="OperatorID"
      option-label="Operator"
      borderless
      :clearable="persistentOperatorFilter.OperatorID === 0 ? false : true"
      clear-icon="close"
      color="secondary"
      @input="
        setOperator(
          selectedOperator ? selectedOperator.OperatorID : 0,
          selectedOperator ? selectedOperator.Operator : ''
        )
      "
      @clear="setOperator(0, '')"
      :behavior="$q.platform.is.ios === true ? 'dialog' : 'menu'"
    >
      <template v-slot:option="scope">
        <q-item
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
          class="select__options--item"
        >
          <q-item-section>
            <q-item-label v-html="scope.opt.Operator" />
          </q-item-section>
        </q-item>
      </template>
      <template v-slot:before>
        <span class="select__label">Operator:</span>
      </template>
    </q-select>
    <!-- Network -->
    <q-select
      class="select"
      :display-value="
        ` ${
          persistentNetworkFilter.id === 0
            ? 'All Networks'
            : persistentNetworkFilter.name
        }`
      "
      virtual-scroll-slice-size="30"
      virtual-scroll-item-size="30"
      popup-content-class="select__options"
      dense
      options-dense
      v-model="selectedNetwork"
      :options="networkList"
      option-value="NetworkID"
      option-label="Network"
      borderless
      :clearable="persistentNetworkFilter.id === 0 ? false : true"
      clear-icon="close"
      color="secondary"
      @input="
        setNetwork(
          selectedNetwork ? selectedNetwork.NetworkID : 0,
          selectedNetwork ? selectedNetwork.Network : ''
        )
      "
      @clear="setNetwork(0, '')"
      :behavior="$q.platform.is.ios === true ? 'dialog' : 'menu'"
    >
      <template v-slot:option="scope">
        <q-item
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
          class="select__options--item"
        >
          <q-item-section>
            <q-item-label v-html="scope.opt.Network" />
          </q-item-section>
        </q-item>
      </template>
      <template v-slot:before>
        <span class="select__label">Network:</span>
      </template>
    </q-select>
    <!-- Sites -->
    <q-select
      class="select"
      :display-value="
        ` ${
          persistentSiteFilter.id === 0
            ? 'All Sites'
            : persistentSiteFilter.name
        }`
      "
      virtual-scroll-slice-size="30"
      virtual-scroll-item-size="30"
      popup-content-class="select__options"
      dense
      options-dense
      v-model="selectedSite"
      :options="siteList"
      option-value="SiteID"
      option-label="Site"
      borderless
      :clearable="persistentSiteFilter.id === 0 ? false : true"
      clear-icon="close"
      color="secondary"
      @input="
        setSite(
          selectedSite ? selectedSite.SiteID : 0,
          selectedSite ? selectedSite.Site : ''
        )
      "
      @clear="setSite(0, '')"
      :behavior="$q.platform.is.ios === true ? 'dialog' : 'menu'"
    >
      <template v-slot:option="scope">
        <q-item
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
          class="select__options--item"
        >
          <q-item-section>
            <q-item-label v-html="scope.opt.Site" />
          </q-item-section>
        </q-item>
      </template>
      <template v-slot:before>
        <span class="select__label">Site:</span>
      </template>
    </q-select>
    <!-- Trading Overview Filters -->
    <q-select
      v-if="extendedFilter === true"
      :display-value="
        ` ${
          this.persistentViewFilter.label
            ? this.persistentViewFilter.label
            : 'Day'
        }`
      "
      class="select"
      popup-content-class="select__options"
      dense
      options-dense
      v-model="selectedView"
      :options="views"
      option-value="value"
      option-label="label"
      borderless
      color="secondary"
      :behavior="$q.platform.is.ios === true ? 'dialog' : 'menu'"
      @input="setView(selectedView)"
    >
      <template v-slot:option="scope">
        <q-item
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
          class="select__options--item"
        >
          <q-item-section>
            <q-item-label v-html="scope.opt.label" />
          </q-item-section>
        </q-item>
      </template>
      <template v-slot:before>
        <span class="select__label">Time Period:</span>
      </template>
    </q-select>
  </div>
</template>

<script>
export default {
  name: "SiteSelector",
  props: {
    extendedFilter: Boolean,
  },
  data() {
    return {
      operatorList: [],
      selectedOperator: 0,
      networkList: [],
      selectedNetwork: 0,
      siteList: [],
      selectedSite: 0,
      filterOption: {
        operator: 0,
        site: 0,
        network: 0,
      },
      persistentOperatorFilter: {
        OperatorID: 0,
        Operator: "",
      },
      persistentNetworkFilter: {
        id: 0,
        name: "",
      },
      persistentSiteFilter: {
        id: 0,
        name: "",
      },
      views: [
        { label: "Day", value: "day" },
        { label: "Week", value: "week" },
        { label: "Month", value: "month" },
      ],
      selectedView: "",
      persistentViewFilter: { label: "Day", value: "day" },
    };
  },

  methods: {
    // Operator change action: Reset network and site, commit to store then refresh reports based on new selection.
    setOperator(operatorId, operName) {
      // Commit the selected operator to the store.
      this.$store.commit("SET_OPERATOR", {
        selectedOperatorId: operatorId ? operatorId : 0,
        id: operatorId ? operatorId : 0,
        name: operName,
      });

      // Update the filters on this page.
      this.persistentOperatorFilter = {
        OperatorID: operatorId,
        Operator: operName,
      };
      this.persistentNetworkFilter = { id: 0, name: "" };
      this.persistentSiteFilter = { id: 0, name: "" };

      // Clear network and site in store and model if an operator selection changes.
      this.$store.commit("SET_NETWORK", {
        selectedNetworkId: 0,
        id: 0,
        name: "",
      });
      this.selectedNetwork = 0;
      this.$store.commit("SET_SITE", {
        selectedSiteId: 0,
        id: 0,
        name: "",
      });
      this.selectedSite = 0;

      // Refresh the network and site lists based on the selected operator
      this.fetchNetwork(operatorId ? operatorId : 0);
      this.fetchSites(operatorId ? operatorId : 0, null);

      // Emit update filter signal to containing dashboard to trigger refresh of grid on filter selection change.
      const filterSelection = {
        view: this.persistentViewFilter,
        siteId: 0,
        networkId: 0,
        operatorId: operatorId ? operatorId : 0,
      };
      this.$emit("updateFilter", filterSelection);
    },

    // Network action
    setNetwork(networkId, networkName) {
      // Commit the selected network to the store.
      this.$store.commit("SET_NETWORK", {
        selectedNetworkId: networkId ? networkId : 0,
        id: networkId ? networkId : 0,
        name: networkName ? networkName : "",
      });

      // Update the filters on this page.
      this.persistentNetworkFilter = { id: networkId, name: networkName };
      this.persistentSiteFilter = { id: 0, name: "" };

      // Clear site in store and model if network selection changes.
      this.$store.commit("SET_SITE", {
        selectedSiteId: 0,
        id: 0,
        name: "",
      });
      this.selectedSite = 0;

      // Refresh site list based on the network selection.
      this.fetchSites(
        this.persistentOperatorFilter.OperatorID,
        networkId ? networkId : null
      );

      // Emit update filter signal to containing dashboard to trigger refresh of grid on filter selection change.
      const filterSelection = {
        view: this.persistentViewFilter,
        siteId: 0,
        networkId: networkId ? networkId : 0,
        operatorId: this.persistentOperatorFilter.OperatorID,
      };
      this.$emit("updateFilter", filterSelection);
    },

    // Set selected site else show all sites
    setSite(siteId, siteName) {
      // Commit the site selection to the store.
      this.$store.commit("SET_SITE", {
        selectedSiteId: siteId ? siteId : 0,
        id: siteId ? siteId : 0,
        name: siteName,
      });

      // Set the site filter for this page.
      this.persistentSiteFilter = { id: siteId, name: siteName };

      // Emit update filter signal to containing dashboard to trigger refresh of grid on filter selection change.
      const filterSelection = {
        view: this.persistentViewFilter,
        siteId,
        networkId: this.persistentNetworkFilter.id,
        operatorId: this.persistentOperatorFilter.OperatorID,
      };
      this.$emit("updateFilter", filterSelection);
    },

    // Set selected view
    setView(view) {
      this.$store.commit("SET_VIEW", {
        selectedView: view,
      });
      // Set the view filter for this page.
      this.persistentViewFilter = view;

      // Emit update filter signal to containing dashboard to trigger refresh of grid on filter selection change.
      const filterSelection = {
        view: view,
        siteId: this.persistentSiteFilter.id,
        networkId: this.persistentNetworkFilter.id,
        operatorId: this.persistentOperatorFilter.OperatorID,
      };
      this.$emit("updateFilter", filterSelection);
    },

    // Fetch all data
    fetchOperator() {
      // No dataset or filter options for operator list, store will handle operator ID.
      const payload = {
        filterOptions: {},
        report: "operator-list",
        dataset: "",
      };

      this.$store
        .dispatch("fetchData", payload)
        .then((response) => {
          this.operatorList = response.data;
        })
        .catch((error) => {
          this.errors.push(error);
        });
    },
    fetchNetwork(operatorId) {
      // No dataset for network list, store will handle operator ID if not supplied.
      const payload = {
        filterOptions: { operatorId },
        report: "network-list",
        dataset: "",
      };

      this.$store
        .dispatch("fetchData", payload)
        .then((response) => {
          if (response.data.length == 0) {
            this.networkList = [{ Network: "None", NetworkID: 0 }];
          } else {
            this.networkList = response.data;
          }
        })
        .catch((error) => {
          this.errors.push(error);
        });
    },
    fetchSites(operatorId, networkId) {
      // No dataset for network list, store will handle operator ID if not supplied.
      const payload = {
        filterOptions: {
          operatorId,
          networkId,
        },
        report: "user-site-list",
        dataset: "",
      };

      this.$store
        .dispatch("fetchData", payload)
        .then((response) => {
          this.siteList = response.data;
        })
        .catch((error) => {
          this.errors.push(error);
        });
    },
  },

  mounted() {
    // Get the stored operator filter for persistent storage after refresh.
    this.persistentOperatorFilter = {
      OperatorID: this.$store.state.selectedOperator.id
        ? this.$store.state.selectedOperator.id
        : 0,
      Operator: this.$store.state.selectedOperator.name
        ? this.$store.state.selectedOperator.name
        : "",
    };

    // Get the stored network filter for persistent storage after refresh.
    this.persistentNetworkFilter = {
      id: this.$store.state.networkFilter.id
        ? this.$store.state.networkFilter.id
        : 0,
      name: this.$store.state.networkFilter.name
        ? this.$store.state.networkFilter.name
        : "",
    };

    // Get the stored site filter for persistent storage after refresh.
    this.persistentSiteFilter = {
      id: this.$store.state.siteFilter.id ? this.$store.state.siteFilter.id : 0,
      name: this.$store.state.siteFilter.name
        ? this.$store.state.siteFilter.name
        : "",
    };

    // Get the store view filter for persistent storage after refresh.
    this.persistentViewFilter = {
      label: this.$store.state.selectedView.label,
      value: this.$store.state.selectedView.value,
    };

    // Fetch all filter lists on load. Use persistent operator and networks if set.
    this.fetchOperator();
    this.fetchNetwork(
      this.persistentOperatorFilter.OperatorID
        ? this.persistentOperatorFilter.OperatorID
        : this.$store.state.userDetails.operatorId
    );
    this.fetchSites(
      this.persistentOperatorFilter.OperatorID
        ? this.persistentOperatorFilter.OperatorID
        : this.$store.state.userDetails.operatorId,
      this.persistentNetworkFilter.id
    );
  },

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.filter {
  display: flex;
  flex: auto;
  flex-direction: column;
  // Slightly larger min-width than normal due to text heavy fitler options values causing styling breaks in tablet mode
  @media only screen and (min-width: 860px) {
    flex-direction: row;
  }
  .select {
    width: 100%;
    min-width: 220px;
    max-width: 100%;
    margin-right: 0;
    @media only screen and (min-width: 860px) {
      width: 100%;
      min-width: 180px;
      max-width: 33.333%;
      margin-right: 2em;
      &:last-of-type {
        margin-right: 0;
      }
    }
    // Larger desktops move towards a left aligned approach as becomes hard to see filters if full width of screen
    @media only screen and (min-width: 1300px) {
      width: 100%;
      min-width: 220px;
      max-width: 300px;
      margin-right: 2em;
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
  &--extended {
    // Change layout for extended filter
    .select {
      width: 100%;
      min-width: 120px;
      max-width: 100%;
      margin-right: 0;
      @media only screen and (min-width: 860px) {
        width: 100%;
        min-width: 120px;
        max-width: 33.333%;
        margin-right: 2em;
        &:last-of-type {
          margin-right: 0;
        }
      }
      // Larger desktops move towards a left aligned approach as becomes hard to see filters if full width of screen
      @media only screen and (min-width: 1300px) {
        width: 100%;
        min-width: 120px;
        max-width: 200px;
        margin-right: 2em;
        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }
  .filter-extra {
    display: flex;
    align-items: center;
    border-left: 0.5px solid #ececec;
    padding: 0 10px;
    &__label {
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: #13110c;
      margin-right: 5px;
    }
  }
}
</style>
